import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Contact.css';

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullName: '',
      email: '',
      phone: '',
      subject: '',
      message: '',
      isSubmitted: false,
      activeFaq: 0 // Default open FAQ item
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { fullName, email, subject, message } = this.state;

    if (!fullName || !email || !subject || !message) {
      alert('Please fill in all required fields.');
      return;
    }

    // Simulate successful form submission
    this.setState({ isSubmitted: true });

    // Reset form after 4 seconds
    setTimeout(() => {
      this.setState({
        fullName: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
        isSubmitted: false
      });
    }, 4000);
  };

  toggleFaq = (index) => {
    this.setState((prevState) => ({
      activeFaq: prevState.activeFaq === index ? null : index
    }));
  };

  render() {
    const { fullName, email, phone, subject, message, isSubmitted, activeFaq } = this.state;

    const contactInfo = [
      {
        icon: 'bi-geo-alt-fill',
        title: 'Our Headquarters',
        details: ['Akhi Tower , House -3/1 Flat -3/A, 3/B, Road -02 Block – C, Bosila City Developer ltd Near to Bosila Bridge, RAB office.', 'Dhaka 1207 Bosila, 1207.'],
        actionText: 'Get Directions',
        actionLink: '#google-map'
      },
      {
        icon: 'bi-telephone-fill',
        title: 'Phone & Concierge',
        details: ['+880 1322 939300'],
        actionText: 'Call Support',
        actionLink: 'tel:+8801322939300'
      },
      {
        icon: 'bi-envelope-fill',
        title: 'Email Us',
        details: ['support@bookly.com.bd'],
        actionText: 'Send Email',
        actionLink: 'mailto:support@bookly.com.bd'
      },
      {
        icon: 'bi-whatsapp',
        title: 'WhatsApp Instant',
        details: ['+880 1322 939300', 'Available 24/7 for fast booking assistance'],
        actionText: 'Chat on WhatsApp',
        actionLink: 'https://wa.me/8801322939300'
      },
      {
        icon: 'bi-clock-fill',
        title: 'Operating Hours',
        details: ['Customer Support: 24/7 / 365 Days', 'Partner Services: 9:00 AM – 6:00 PM'],
        actionText: 'Always Open',
        actionLink: '#'
      }
    ];

    const whyContactFeatures = [
      {
        icon: 'bi-headset',
        title: '24/7 Customer Support',
        description: 'Our global concierge team is available around the clock to assist with your stays.'
      },
      {
        icon: 'bi-lightning-charge-fill',
        title: 'Fast Response',
        description: 'We respond to all inquiries within 15 minutes to keep your trip planning seamless.'
      },
      {
        icon: 'bi-shield-lock-fill',
        title: 'Secure Booking Assistance',
        description: 'Need help with payments or modifications? Your security is our top priority.'
      },
      {
        icon: 'bi-person-badge-fill',
        title: 'Trusted Travel Experts',
        description: 'Get personalized recommendations from destination specialists who know best.'
      }
    ];

    const faqs = [
      {
        q: 'How do I modify or cancel my Bookly reservation?',
        a: 'You can easily manage your reservation by logging into your Bookly account, going to "My Bookings", and selecting the reservation you wish to modify or cancel according to the property cancellation policy.'
      },
      {
        q: 'Are there any hidden service or booking fees?',
        a: 'No. Bookly practices 100% price transparency. The total price displayed on your checkout screen includes all applicable taxes and mandatory property fees.'
      },
      {
        q: 'What should I do if I need to check in late at night?',
        a: 'Simply notify us through your booking confirmation or message your host directly via Bookly. Most of our partner hotels and apartments offer 24/7 front desk service or keyless self-check-in.'
      },
      {
        q: 'How can I partner with or list my property on Bookly?',
        a: 'We welcome high-quality hotels and apartments! Fill out our contact form selecting "Partner / Property Listing" as the subject, and our host onboarding team will reach out to you within 24 hours.'
      }
    ];

    return (
      <div className="contact-us-page">
        {/* 1. Hero Banner */}
        <section className="contact-hero position-relative d-flex align-items-center justify-content-center text-center">
          <div className="hero-overlay"></div>
          <div className="container position-relative z-2 text-white">
            <span className="badge bg-white text-primary-blue px-3 py-2 rounded-pill fw-bold mb-3 shadow-sm text-uppercase tracking-wide">
              We're Here For You
            </span>
            <h1 className="display-4 fw-bold mb-3 animate-fade-up">Get in Touch with Bookly</h1>
            <p className="lead mx-auto text-light opacity-90 animate-fade-up delay-1" style={{ maxWidth: '720px' }}>
              Have a question about a stay, need assistance with your booking, or planning a custom travel itinerary? Our dedicated support team is ready to help 24/7.
            </p>
          </div>
        </section>

        {/* 2. Contact Information Cards */}
        <section className="py-5 bg-light-gray position-relative" style={{ marginTop: '-40px', zIndex: 10 }}>
          <div className="container">
            <div className="row g-4 justify-content-center">
              {contactInfo.map((info, index) => (
                <div key={index} className="col-12 col-sm-6 col-lg-4">
                  <div className="contact-info-card h-100 p-4 rounded-4 bg-white shadow-sm hover-lift border">
                    <div className="info-icon-wrapper mb-3">
                      <i className={`bi ${info.icon} fs-3`}></i>
                    </div>
                    <h5 className="fw-bold text-dark-navy mb-2">{info.title}</h5>
                    {info.details.map((line, idx) => (
                      <p key={idx} className="text-muted small mb-1">{line}</p>
                    ))}
                    {info.actionLink !== '#' && (
                      <a href={info.actionLink} className="contact-card-link d-inline-flex align-items-center gap-2 mt-3 fw-bold small text-primary-blue">
                        {info.actionText} <i className="bi bi-arrow-right"></i>
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 3. Main Contact Section: Form & Google Map */}
        <section className="py-5 bg-white">
          <div className="container py-4">
            <div className="row g-5 align-items-stretch">
              
              {/* Left Column: Contact Form */}
              <div className="col-lg-7">
                <div className="form-wrapper p-4 p-md-5 rounded-4 shadow-sm border bg-white h-100">
                  <span className="text-primary-blue text-uppercase fw-bold tracking-wide small">Send Us A Message</span>
                  <h2 className="display-6 fw-bold mt-1 mb-3 text-dark-navy">How Can We Help You?</h2>
                  <p className="text-muted mb-4">
                    Fill out the form below and our team will get back to you within 15 minutes.
                  </p>

                  {isSubmitted && (
                    <div className="alert alert-success rounded-3 d-flex align-items-center gap-3 p-3 mb-4" role="alert">
                      <i className="bi bi-check-circle-fill fs-4"></i>
                      <div>
                        <strong>Thank you!</strong> Your message has been sent successfully. A Bookly specialist will contact you shortly.
                      </div>
                    </div>
                  )}

                  <form onSubmit={this.handleSubmit}>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label className="form-label fw-bold small text-dark-navy">Full Name *</label>
                        <div className="input-group">
                          <span className="input-group-text bg-light border-end-0"><i className="bi bi-person text-muted"></i></span>
                          <input 
                            type="text" 
                            className="form-control border-start-0" 
                            name="fullName"
                            placeholder="John Doe" 
                            value={fullName}
                            onChange={this.handleInputChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label fw-bold small text-dark-navy">Email Address *</label>
                        <div className="input-group">
                          <span className="input-group-text bg-light border-end-0"><i className="bi bi-envelope text-muted"></i></span>
                          <input 
                            type="email" 
                            className="form-control border-start-0" 
                            name="email"
                            placeholder="john@example.com" 
                            value={email}
                            onChange={this.handleInputChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label fw-bold small text-dark-navy">Phone Number</label>
                        <div className="input-group">
                          <span className="input-group-text bg-light border-end-0"><i className="bi bi-telephone text-muted"></i></span>
                          <input 
                            type="tel" 
                            className="form-control border-start-0" 
                            name="phone"
                            placeholder="+880 1700 000000" 
                            value={phone}
                            onChange={this.handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <label className="form-label fw-bold small text-dark-navy">Subject *</label>
                        <select 
                          className="form-select" 
                          name="subject"
                          value={subject}
                          onChange={this.handleInputChange}
                          required
                        >
                          <option value="">Select a inquiry subject</option>
                          <option value="Booking Assistance">Booking Assistance</option>
                          <option value="Cancellation / Refund">Cancellation / Refund</option>
                          <option value="Property Listing / Host">Partner / Property Listing</option>
                          <option value="Corporate / Group Booking">Corporate / Group Booking</option>
                          <option value="General Feedback">General Feedback</option>
                        </select>
                      </div>

                      <div className="col-12">
                        <label className="form-label fw-bold small text-dark-navy">Message *</label>
                        <textarea 
                          className="form-control p-3" 
                          name="message"
                          rows="5" 
                          placeholder="Tell us about your trip plans, reservation details, or questions..."
                          value={message}
                          onChange={this.handleInputChange}
                          required
                        ></textarea>
                      </div>

                      <div className="col-12 mt-4">
                        <button type="submit" className="btn btn-primary search-btn py-3 px-5 rounded-pill fw-bold w-100 d-flex align-items-center justify-content-center gap-2">
                          <i className="bi bi-send"></i> Send Message
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              {/* Right Column: Google Map Card */}
              <div className="col-lg-5" id="google-map">
                <div className="map-card h-100 rounded-4 shadow-sm border overflow-hidden position-relative d-flex flex-column">
                  <div className="p-4 bg-dark-navy text-white">
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <i className="bi bi-pin-map-fill text-primary-blue fs-5"></i>
                      <h5 className="fw-bold mb-0">Visit Our Office</h5>
                    </div>
                    <p className="small text-light opacity-75 mb-0">Located in the heart of Dhaka's business district.</p>
                  </div>

                  <div className="flex-grow-1 position-relative min-map-height">
                    <iframe 
                      title="Bookly Location Map"
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3652.0176955249876!2d90.34778087533583!3d23.74674837867283!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755bfbbfd17fb3f%3A0x2d4305cbd1bd0b49!2zQWtoaSBUb3dlciDgpobgpoHgppbgpr8g4Kaf4Ka-4KaT4Kef4Ka-4Kaw!5e0!3m2!1sen!2sbd!4v1785771532245!5m2!1sen!2sbd" 
                      width="100%" 
                      height="100%" 
                      style={{ border: 0, minHeight: '350px' }} 
                      allowFullScreen="" 
                      loading="lazy"
                    ></iframe>
                  </div>

                  <div className="p-3 bg-light border-top text-center">
                    <span className="small text-muted fw-medium">
                      <i className="bi bi-shield-check text-success me-1"></i> Parking available for visitors
                    </span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* 4. Why Contact Bookly Section */}
        <section className="py-5 bg-light-gray">
          <div className="container py-4">
            <div className="text-center mb-5">
              <span className="text-primary-blue text-uppercase fw-bold tracking-wide small">The Bookly Promise</span>
              <h2 className="display-6 fw-bold mt-1 text-dark-navy">Why Contact Bookly?</h2>
            </div>

            <div className="row g-4">
              {whyContactFeatures.map((feature, idx) => (
                <div key={idx} className="col-md-6 col-lg-3">
                  <div className="why-card p-4 rounded-4 bg-white shadow-sm h-100 text-center hover-lift border">
                    <div className="why-icon-wrapper mx-auto mb-3">
                      <i className={`bi ${feature.icon} fs-2 text-primary-blue`}></i>
                    </div>
                    <h5 className="fw-bold text-dark-navy mb-2">{feature.title}</h5>
                    <p className="text-muted small mb-0 line-height-md">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 5. Frequently Asked Questions */}
        <section className="py-5 bg-white">
          <div className="container py-4" style={{ maxWidth: '900px' }}>
            <div className="text-center mb-5">
              <span className="text-primary-blue text-uppercase fw-bold tracking-wide small">Have Questions?</span>
              <h2 className="display-6 fw-bold mt-1 text-dark-navy">Frequently Asked Questions</h2>
            </div>

            <div className="faq-container">
              {faqs.map((faq, index) => {
                const isOpen = activeFaq === index;
                return (
                  <div key={index} className={`faq-item mb-3 rounded-4 border ${isOpen ? 'active-faq' : ''}`}>
                    <button 
                      className="faq-question w-100 p-4 text-start bg-transparent border-0 d-flex align-items-center justify-content-between fw-bold text-dark-navy"
                      onClick={() => this.toggleFaq(index)}
                    >
                      <span className="fs-6">{faq.q}</span>
                      <i className={`bi ${isOpen ? 'bi-chevron-up text-primary-blue' : 'bi-chevron-down text-muted'}`}></i>
                    </button>
                    {isOpen && (
                      <div className="faq-answer px-4 pb-4 text-muted line-height-lg animate-fade-in">
                        {faq.a}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* 6. Call To Action Section */}
        <section className="contact-cta py-5 position-relative">
          <div className="container py-5 position-relative z-2 text-center text-white">
            <h2 className="display-5 fw-bold mb-3">Ready to Book Your Next Stay?</h2>
            <p className="lead mb-4 opacity-90 mx-auto" style={{ maxWidth: '650px', color: 'white' }}>
              Explore over 15,000 handpicked hotels, luxury villas, and city apartments across the globe with instant confirmation.
            </p>
            <div className="d-flex justify-content-center gap-3 flex-wrap">
              <a href="/search" className="btn btn-primary btn-lg rounded-pill px-5 py-3 fw-bold shadow-lg hover-scale">
                Book Your Stay <i className="bi bi-arrow-right ms-2"></i>
              </a>
              <a href="tel:+8801700000000" className="btn btn-outline-light btn-lg rounded-pill px-5 py-3 fw-bold hover-scale">
                <i className="bi bi-telephone-outbound me-2"></i> Speak with Concierge
              </a>
            </div>
          </div>
          <div className="cta-overlay"></div>
        </section>
      </div>
    );
  }
}

export default Contact;